import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import MapComponent from "../../../Components/Maps/MapComponent";
import '../../../Styles/Print.css';

const RotogramaViagemPrint = (props: any) => {
    const [marcadores, setMarcadores] = useState<any[]>([]);
    const [dados, setDados] = useState<any>({});
    const [coordenadas, setCoordenadas] = useState<any[]>([]);
    const [posicoes, setPosicoes] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [urlRelatorio, setUrlRelatorio] = useState('');
    const { id } = useParams<{ id: string }>();
    const { enqueueSnackbar } = useSnackbar();
    
    const estiloDesvio = {'Desvio de Rota': 'rgb(235 85 85)', 'dentro da rota': 'rgb(138 245 124)'};
    const estiloAtraso = {
        'atrasado': 'rgb(235 85 85)',
        'adiantado': 'rgb(102 132 237)',
        'tendencia de atraso': 'rgb(244 245 124)',
        'no prazo': 'rgb(138 245 124)'
    };

    const consulta_rota_maps = 'https://api.qrserver.com/v1/create-qr-code/?data=';

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);
                
                const response = await axios.get(`/rotograma/buscaDados?viagemId=${id}`);
                const dadosViagem = response.data;
                setDados(dadosViagem);
                setUrlRelatorio(`https://c2tower.grupokrona.com.br/rotograma/${dadosViagem.guid}`);

                const { marcadores: novosMarcadores, coordenadas: novasCoordenadas } = processarDadosMapa(dadosViagem);
                setMarcadores(novosMarcadores);
                setCoordenadas(novasCoordenadas);

                const partUrl = props.simplePage ? 'Simple' : '';
                const code = props.simplePage ? 'guid' : 'viagemId';
                const posicoesResponse = await axios.get(`/rotograma${partUrl}/buscaPosicoes?${code}=${id}`);
                setPosicoes(posicoesResponse.data);

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
                enqueueSnackbar('Erro ao carregar dados', {variant: 'error'});
            } finally {
                setLoading(false);
                handlePrint();
            }
        };

        fetchAllData();
    }, [id, props.simplePage]);

    const processarDadosMapa = (dadosViagem: any) => {
        const marcadores: any[] = [];
        let coordenadasInvertidas: any[] = [];

        marcadores.push({
            dados: getDadosViagem(dadosViagem, true),
            latitude: dadosViagem.latitude,
            longitude: dadosViagem.longitude,
            tipo: 'Posição',
            cor: 'gold',
            type: 'truck'
        });

        marcadores.push({
            dados: getDadosOrigem(dadosViagem),
            latitude: dadosViagem.latitude_origem,
            longitude: dadosViagem.longitude_origem,
            tipo: 'Origem',
            cor: 'green',
            raio: dadosViagem.raio_origem,
            poligono: dadosViagem.poligono_origem
        });

        dadosViagem.destinos?.forEach((destino: any, index: number) => {
            marcadores.push({
                dados: getDestinoCard(dadosViagem, index, index === dadosViagem.destinos.length - 1),
                latitude: destino.latitude,
                longitude: destino.longitude,
                tipo: 'Destino',
                cor: 'blue',
                raio: destino.raio,
                poligono: destino.poligono
            });
        });

        dadosViagem.paradas_nao_autorizadas?.forEach((parada: any) => {
            marcadores.push({
                dados: getCardGenerico(parada, "Parada não Autorizada", parada.descricao),
                latitude: parada.latitude,
                longitude: parada.longitude,
                tipo: 'NaoAutorizada',
                cor: 'red',
                raio: parada.raio
            });
        });

        dadosViagem.areas_risco?.forEach((area_risco: any) => {
            marcadores.push({
                dados: getCardGenerico(area_risco, "Área de Risco", area_risco.descricao),
                latitude: area_risco.latitude,
                longitude: area_risco.longitude,
                tipo: 'Risco',
                cor: 'grey',
                raio: area_risco.raio
            });
        });

        dadosViagem.alertas_macros?.forEach((alerta_macro: any) => {
            marcadores.push({
                dados: getCardGenerico(alerta_macro, "Alerta / Macro / Violação", alerta_macro.evento),
                latitude: alerta_macro.latitude,
                longitude: alerta_macro.longitude,
                tipo: 'AlertaMacro',
                cor: 'black'
            });
        });

        if (dadosViagem.coordenadas) {
            coordenadasInvertidas = dadosViagem.coordenadas.split(';')
                .map((pair: string) => {
                    const [lat, lng] = pair.split(',').map(Number);
                    if (isNaN(lat) || isNaN(lng)) return null;
                    return [lng, lat];
                })
                .filter((coord: any) => coord !== null);
        }

        return { marcadores, coordenadas: coordenadasInvertidas };
    };

    function getCardGenerico(dados: any, titulo: string, descricao: string) {
        return (
            <div>
                <table className="tabelaMapa" style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td colSpan={2}>
                                <strong>{titulo}</strong><br />
                            </td>
                        </tr>
                        <tr>
                            <td>Descrição</td><td>{descricao}</td>
                        </tr>
                        <tr>
                            <td>Data/Hora</td><td>{dados.datahoraevento}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );    
    }
    
    function getTableLinePercentual(value: any, label: string) {
        if (value == 0 || value == null || value == '') {
            return null;
        }
        return (
            <tr>
                <td><strong>{label}</strong></td>
                <td>
                    <div style={{
                        width: '100%',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '5px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            width: `${value}%`,
                            backgroundColor: '#4caf50',
                            height: '10px',
                            borderRadius: '5px'
                        }}></div>
                    </div>
                    <span>{value}%</span>
                </td>
            </tr>
        );
    }

    function getTableLineValue(value: any, label: string, verificarNulo: boolean = true, estilo: any = null, circle: boolean = false) {
        if (verificarNulo && (value == 0 || value == null || value == '')) {
            return null;
        }
        
        let content;
        if (estilo) {
            const colorKey = Object.keys(estilo).find(
                key => key.toLowerCase().includes(String(value).toLowerCase())
            );
            const color = colorKey ? estilo[colorKey] : null;
            
            if (color) {
                content = (
                    <tr className={circle ? 'point' : ''}>
                        <td><strong>{label}</strong></td>
                        <td className="styleBold" style={{fontWeight: 'bold', backgroundColor: color}}>
                            {value}
                        </td>
                    </tr>
                );
            } else {
                content = (
                    <tr className={circle ? 'point' : ''}>
                        <td><strong>{label}</strong></td>
                        <td>{value ?? ''}</td>
                    </tr>
                );
            }
        } else {
            content = (
                <tr className={circle ? 'point' : ''}>
                    <td><strong>{label}</strong></td>
                    <td>{value ?? ''}</td>
                </tr>
            );
        }
        
        return content;
    }

    function getDadosViagem(dados: any, card: boolean = false) {
        return (
            <table className="tabelaMapa" style={{ width: '100%' }}>
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <strong>DADOS VIAGEM</strong>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '0 5px 5px 5px' }}>
                            <table style={{ width: '100%' }}>
                                <tbody>
                                    {getTableLineValue(dados.id, 'Número Viagem')}
                                    {getTableLineValue(dados.operacao, 'Operação')}
                                    {getTableLineValue(dados.motorista1, 'Motorista 1')}
                                    {getTableLineValue(dados.motorista2, 'Motorista 2')}
                                    {getTableLineValue(dados.inicio_real, 'Início real')}
                                    {getTableLineValue(dados.fim_real, 'Fim real', false)}
                                    {getTableLineValue(
                                        dados.desvio_rota ? 'Desvio de Rota' : 'Dentro da Rota',
                                        'Status da rota',
                                        true,
                                        estiloDesvio
                                    )}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    function getDadosOrigem(dados: any) 
    {
        return (
            <table className="tabelaMapa" style={{width: '100%'}}>
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <span><img style={{width:'15px', marginRight: '5px'}} src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png" alt="Origem" /></span>
                            <strong>DADOS ORIGEM</strong>
                        </td>
                    </tr>
                    <tr>
                        <td style={{padding: '0 5px 5px 5px'}}>
                            <table className="table-map" style={{width: '100%'}}>
                                <tbody>
                                    {getTableLinePercentual(dados.porcentagem_percorrida, '% Chegada')}
                                    {getTableLineValue(dados.tendencia_atraso_chegada_origem, 'Tendência de atraso chegada origem', true, estiloAtraso)}
                                    {getTableLineValue(dados.distancia_total, 'Distancia')}
                                    {getTableLineValue(dados.distancia_restante, 'Distancia restante')}
                                    {getTableLineValue(dados.saida_para_origem, 'Saída para origem', false, null, true)}
                                    {getTableLineValue(dados.tempo_previsto, 'Tempo previsto')}
                                    {getTableLineValue(dados.tempo_restante, 'Tempo restante')}
                                    {getTableLineValue(dados.chegada_prevista_ajustada, 'Chegada prevista ajustada', true, null, true)}
                                    {getTableLineValue(dados.tempo_real, 'Tempo até agora')}
                                    {getTableLineValue(dados.carregamento_previsto, 'Previsão chegada', false, null, true)}
                                    {getTableLineValue(dados.entrada_raio_origem, 'Chegada real', false, null, true)}
                                    {getTableLineValue(dados.tempo_atraso, 'Tempo atraso')}
                                    {getTableLineValue(dados.inicio_previsto, 'Previsão início', false, null, true)}
                                    {getTableLineValue(dados.saida_raio_origem, 'Saída real', false, null, true)}
                                    {getTableLineValue(dados.tempo_permanencia, 'Tempo permanência')}
                                    {getTableLineValue(dados.tendencia_de_atraso_permanencia, 'Tendência de atraso permanência', true, estiloAtraso)}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    function getDadosDestinoFinal(dados: any) {
        return (
            <table className="tabelaMapa" style={{width: '100%'}}>
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <span><img style={{width:'15px', marginRight: '5px'}} src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png" alt="Destino" /></span>
                            <strong>DADOS DESTINO FINAL</strong>
                        </td>
                    </tr>
                    <tr>
                        <td style={{padding: '0 5px 5px 5px'}}>
                            <table style={{width: '100%'}}>
                                <tbody>
                                    {getTableLinePercentual(dados.percentual_viagem, '% Percorrida')}
                                    {getTableLineValue(dados.tendencia_atraso_chegada_destino, 'Tendência de atraso chegada', true, estiloAtraso)}
                                    {getTableLineValue(dados.distancia_total_viagem, 'Distância total')}
                                    {getTableLineValue(dados.distancia_percorrida_viagem, 'Distância percorrida')}
                                    {getTableLineValue(dados.chegada_prevista_viagem, 'Chegada prevista')}
                                    {getTableLineValue(dados.chegada_estimada_destino, 'Chegada estimada')}
                                    {getTableLineValue(dados.entrada_raio_destino, 'Chegada real', false)}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    function getDestinoCard(dados: any, index: any = null, isLast: boolean = false) {
        const destino = dados.destinos?.[index];
        if (!destino) return null;
        
        return (
            <div>
                <table className="tabelaMapa" style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td colSpan={2}>
                                <strong>Destino {index + 1}: {destino.nome}</strong>
                            </td>
                        </tr>
                        {getTableLinePercentual(destino.porcentagem_percorrida, 'Porcentagem')}
                        {getTableLineValue(destino.distancia_tendencia_atraso, 'Tendência de atraso', true, estiloAtraso, true)}
                        {getTableLineValue(destino.distancia_prevista_total, 'Distância')}
                        {getTableLineValue(destino.chegada_prevista, 'Chegada prevista')}
                        {getTableLineValue(destino.chegada_estimada, 'Chegada estimada')}
                        {getTableLineValue(destino.entrada_raio, 'Chegada real')}
                        {getTableLineValue(destino.saida_raio, 'Saída Real')}
                        {getTableLineValue(destino.tempo_permanencia, 'Tempo de permanência')}
                        {getTableLineValue(destino.tendencia_atraso_permanencia, 'Tendência de atraso permanência')}
                    </tbody>
                </table>
            </div>
        );    
    }

    const dadosViagemJSX = useMemo(() => getDadosViagem(dados), [dados]);
    const dadosOrigemJSX = useMemo(() => getDadosOrigem(dados), [dados]);
    const dadosDestinoJSX = useMemo(() => getDadosDestinoFinal(dados), [dados]);

    const handlePrint = () => {
        setTimeout(() => {
            window.print();
        }, 500);
    };

    if (loading) {
        return (
            <div className="text-center mt-5">
                <h4 style={{ color: '#FFFF' }}>
                    Carregando dados da viagem... <br /> Aguarde.
                </h4>
            </div>
        );
    }

    return( 
        <div className="print-page">
            <div className="container-fluidPrint col-md-12">
                <div className= "mt-3 p-5 col-md-12 align-items-center">
                    <div className="header-print">
                        <div>
                            <img src="/Logo_C2_TOWER.svg" width={'200em'} className="logo-main" />
                            <h2 className="h2-print">Rotograma de Viagem</h2>
                        </div>

                        <div className="qr-code-box">
                            <img 
                            src={`${consulta_rota_maps}=${urlRelatorio}&size=150x150`} />
                        </div>
                    </div>

                    <div className="col-md-12">
                        {dadosViagemJSX}
                        <br />
                        {dadosOrigemJSX}
                        <br />
                        {dadosDestinoJSX}
                        <br />
                        {(dados.destinos && dados.destinos.length > 1) && (
                            <table className="tabelaMapa" style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td colSpan={2}>
                                            <strong>DADOS DESTINOS INTERMEDIÁRIOS</strong>
                                        </td>
                                    </tr>
                                    {dados.destinos.map((destino: any, index: number) => (
                                        !destino.isLast && (
                                            <tr key={index}>
                                                <td colSpan={2} style={{ padding: '0 5px 5px 5px' }}>
                                                    {getDestinoCard(dados, index, index === dados.destinos.length - 1)}
                                                </td>
                                            </tr>
                                        )
                                    ))}
                                </tbody>
                            </table>
                        )}
                        <br />
                    </div>
                </div> 

                <div map-wrapper>
                    <div className="map-containerPrint col-md-12 mt-3 p-5" style={{width:'100%'}}>
                        {(marcadores==null || marcadores.length == 0 ? '' : 
                        <div style={{width:'100%'}}>

                            <div style={{width:'100%', padding: '10px', textAlign: 'center' }}>
                                <hr />
                                <h4>
                                    MAPA
                                </h4>
                                <hr />
                            </div>
                            <div style={{width:'100%', justifyItems: 'center' }}>
                                <MapComponent
                                    minHeight={400}
                                    height={((window.innerHeight) - 190)}
                                    width={'100%'}
                                    zoom={10}
                                    center={[dados.latitude, dados.longitude]}
                                    marcadores={marcadores}
                                    posicoes={posicoes}
                                    coordenadas={coordenadas} />
                            </div>
                            {/*  */}
                        <div className="divLegendaMapa">
                                <div className="grupo-linhas">
                                    <span style={{borderBottom: '4px solid blue', color:'#0000c3'}}>Planejado</span>
                                    <span style={{borderBottom: '3px dashed red', color:'#d90000'}}>Percorrido</span>
                                </div>

                                <label>
                                    <img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png" /> 
                                    Não Autorizada
                                </label>

                                <label>
                                    <img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png" /> 
                                    Área de Risco
                                </label>

                                <label>
                                    <img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-black.png" /> 
                                    Macro / Alerta / Violação
                                </label>
                            </div>

                        </div>
                        )}
                    </div>
                </div>

                <div className="no-print">
                    <button className="btn btn-dark" onClick={handlePrint}>
                        <i className="fa fa-print me-2"></i> Imprimir
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RotogramaViagemPrint;